import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class seeAlso {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      centerInsufficientSlides: true,
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1.75,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 2.5,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
        1279: {
          slidesPerView: 6,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: this.strip.find('.swiper-button-next')[0],
        prevEl: this.strip.find('.swiper-button-prev')[0],
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default seeAlso
